import type {
  CongressCountdown,
  CongressCountdownCopy,
} from "../ui/CongressCard";

/**
 * The days · hours · minutes chips of a congress before it opens (Figma DS
 * "CongressStatus", Status=Pre: "1d" "21h" "00m" in white on slate 800),
 * shared by the room banner, the For you block and the space page's phase
 * band.
 */
export function DesktopCongressCountdown({
  countdown,
  copy,
}: {
  countdown: Extract<CongressCountdown, { phase: "pre" }>;
  copy: CongressCountdownCopy;
}): React.JSX.Element {
  const chips = [
    { value: String(countdown.days), unit: copy.daysUnit },
    { value: String(countdown.hours), unit: copy.hoursUnit },
    {
      value: String(countdown.minutes).padStart(2, "0"),
      unit: copy.minutesUnit,
    },
  ];
  return (
    <div className="flex items-start gap-1.5">
      {chips.map((chip) => (
        <span
          key={chip.unit}
          className="rounded-md bg-ds-slate-800 p-2 font-dm-sans text-desktop-body leading-none font-medium whitespace-nowrap text-ds-white tabular-nums"
        >
          {chip.value}
          {chip.unit}
        </span>
      ))}
    </div>
  );
}
